'use strict';

module.exports = removeHttpOrHttpsFilter;

/*@ngInject*/
function removeHttpOrHttpsFilter($filter) {
    return function (url) {
        if (!url) return '';

        var httpPrefix = 'http://';
        var httpsPrefix = 'https://';
        if (url.substr(0, httpPrefix.length) === httpPrefix) {
            return url.substr(httpPrefix.length, url.length);
        } else if (url.substr(0, httpsPrefix.length) === httpsPrefix) {
            return url.substr(httpsPrefix.length, url.length);
        }
        return url;
    };
}


/** WEBPACK FOOTER **
 ** ./app/shared/filters/removeHttpOrHttps.filter.js
 **/